// extracted by mini-css-extract-plugin
export var carousel = "customers-module--carousel--ec5d4";
export var companies = "customers-module--companies--d1863";
export var container = "customers-module--container--16ca4";
export var filter = "customers-module--filter--b9536";
export var filterInfo = "customers-module--filterInfo--ce8ae";
export var filters = "customers-module--filters--1b924";
export var options = "customers-module--options--bc738";
export var page = "customers-module--page--0a699";